import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationRedLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-red-label-slot',
    templateUrl: './medication-red-label-slot.component.html',
    styleUrl: './medication-red-label-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationRedLabelSlotComponent implements SheetSlotComponentBase {

	action!: MedicationRedLabelAction;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationRedLabelAction | null) {
		this.action = action as MedicationRedLabelAction;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}